var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hm-empty l-place:center"},[_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})]),_c('svg',{staticClass:"hm-empty_svg"},[_c('use',{attrs:{"xlink:href":"#empty"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }